<template>
  <div class="container">
    <div v-if="loadingStart">...loading</div>
    <div v-else>
      <div class="content-row">
        <p class="content-heading">Name</p>
        <p class="content-heading">Name (en)</p>
        <p class="content-heading">Account Number</p>
        <p class="content-heading">del</p>
      </div>
      <div
        v-if="banks.length > 0"      
      >
      
      <div
        v-for="bank in banks"
        class="content-row"
        :class="{'selectedRow': bank.id == currentId}"
        :key="bank.id"
        @click="toggleUpdate(bank)"
      >
        <p class="content-col">{{bank.name}}</p>
        <p class="content-col">{{bank.name_en}}</p>
        <p class="content-col">{{bank.number}}</p>
        <div class="content-col">
          <button class="btn btn-danger" type="button" disabled v-if="bank.id === loadingDeleteId">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </button>
          <button class="btn btn-danger" @click.prevent.stop="handleDeleteBank(bank.id)" v-else>
            <i class="far fa-trash-alt"></i>
          </button>
        </div>
      </div>
      </div>
      <div v-else>No inserted banks yet...</div>
    </div>
    <hr />
    <form>
      <h2 v-if="editMode">Update bank</h2>
      <h2 v-else>Add Bank</h2>
      <div class="row">
        <div class="form-group col-12 col-sm-6">
          <label class="pl-0 col-12 col-sm-12" for="name">Name</label>
          <input class="form-control col-12 col-sm-12" v-model="bank.name" />
        </div>
        <div class="form-group col-12 col-sm-6">
          <label class="pl-0 col-12 col-sm-12" for="name_en">Name (en)</label>
          <input class="form-control col-12 col-sm-12" name="name_en" v-model="bank.name_en" />
        </div>
        <div class="form-group col-12 col-sm-6">
          <label class="pl-0 col-12 col-sm-12" for="number">Account Number</label>
          <input type=number class="form-control col-12 col-sm-12" name="number" v-model="bank.number" />
        </div>
      </div>
      <div class="alert alert-danger" role="alert" v-if="errors.length > 0">
        <p v-for="(error, index) in errors" :key="index">{{error}}</p>
      </div>
      <button class="btn btn-primary" type="button" disabled v-if="loading">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Loading
      </button>
      <button v-if="editMode && !loading" class="btn btn-primary" @click.prevent="handleUpdateBank">Update</button>
      <button v-if="editMode && !loading" class="btn btn-success" @click.prevent="switchAddMode">Add More</button>
      <button v-if="!editMode && !loading" class="btn btn-primary" @click.prevent="handleAddBank">Add</button>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { herokuUrl } from "../apiConfig";
import { getCookie } from "../cookie";
export default {
  data() {
    return {
      banks: [],
      bank: {
        name: "",
        name_en: "",
        number: ""
      },
      currentId: null,
      editMode: false,
      loading: false,
      loadingDeleteId: null,
      loadingStart: false,
      errors: []
    };
  },
  methods: {
    handleAddBank: async function() {
      this.errors= []
      if(this.bank.name.length === 0) {
        this.errors.push("Please insert bank name")
      } else if (this.bank.name.length < 3) {
        this.errors.push("Bank name shouldn't be less than 3 characters")
         
      } else if (this.bank.name.length > 50) {
        this.errors.push("Bank name shouldn't be more than 50 characters")
      }

      if(this.bank.name_en.length === 0) {
        this.errors.push("Please insert bank name (en)")
      } else if (this.bank.name_en.length < 3) {
        this.errors.push("Bank name (en) shouldn't be less than 3 characters")
         
      } else if (this.bank.name_en.length > 50) {
        this.errors.push("Bank name (en) shouldn't be more than 50 characters")
      }

      if(this.bank.number.length === 0) {
        this.errors.push("Please insert bank number")
      } else if (this.bank.number.length < 3) {
        this.errors.push("Bank number shouldn't be less than 3 characters")
         
      } else if (this.bank.number.length > 50) {
        this.errors.push("Bank number shouldn't be more than 50 characters")
      }
      if(this.banks.find(b=>{return b.number==this.bank.number})) {
        this.errors.push("Bank number must be unique")
      }

      if (this.errors.length === 0) {
        this.loading = true
        const response = await axios.post(
          `${herokuUrl}/dashboard/add-bank`,
          {
            name_en: this.bank.name_en,
            name: this.bank.name,
            number: this.bank.number
          },
          {
            headers: {
              Authorization: getCookie("user"),
              "Content-Type": "Application/json"
            }
          }
        );
        this.loading = false
        if (response.data.status) {
          // this.banks.push({
          //   id: response.data.id,
          //   name_en: this.bank.name_en,
          //   name: this.bank.name,
          //   number: this.bank.number
          // });
          this.bank.name_en = "";
          this.bank.name = "";
          this.bank.number = "";
          this.fetchBanks();
        }
      }
    },
    toggleUpdate: function(bank) {
      this.editMode = true;
      this.currentId = bank.id;
      this.bank.name = bank.name;
      this.bank.name_en = bank.name_en;
      this.bank.number = bank.number;
    },
    handleUpdateBank: async function() {
      this.errors = []
      if(this.bank.name.length === 0) {
        this.errors.push("Please insert bank name")
      } else if (this.bank.name.length < 3) {
        this.errors.push("Bank name shouldn't be less than 3 characters")
         
      } else if (this.bank.name.length > 50) {
        this.errors.push("Bank name shouldn't be more than 50 characters")
      }

      if(this.bank.name_en.length === 0) {
        this.errors.push("Please insert bank name (en)")
      } else if (this.bank.name_en.length < 3) {
        this.errors.push("Bank name (en) shouldn't be less than 3 characters")
         
      } else if (this.bank.name_en.length > 50) {
        this.errors.push("Bank name (en) shouldn't be more than 50 characters")
      }

      if(this.bank.number.length === 0) {
        this.errors.push("Please insert bank number")
      } else if (this.bank.number.length < 3) {
        this.errors.push("Bank number shouldn't be less than 3 characters")
         
      } else if (this.bank.number.length > 50) {
        this.errors.push("Bank number shouldn't be more than 50 characters")
      }
      if(this.banks.find(b=>{return this.currentId!=b.id && b.number==this.bank.number})) {
        this.errors.push("Bank number must be unique")
      }

      if (this.errors.length === 0) {
        this.loading = true
        const response = await axios.put(`${herokuUrl}/dashboard/update-bank`, 
          {
              bankId: this.currentId,
              name_en: this.bank.name_en,
              name: this.bank.name,
              number: this.bank.number,
          },
          {
            
            headers: {
              Authorization: getCookie("user"),
              "Content-Type": "Application/json"
            }
        })
        this.loading = false;
        if(response.data.status) {
          // const currentIndex = this.banks.findIndex(i => i.id === this.currentId);
          // const beforeIndex = this.banks.slice(0, currentIndex);
          // const afterIndex = this.banks.slice(currentIndex, this.banks.length-1);
  
          // this.banks =[...beforeIndex, { id: this.currentId, name: this.bank.name, name_en: this.bank.name_en, number: this.bank.number }, ...afterIndex]
          this.bank = {
            name: "",
            name_en: "",
            number: ""
          }
          this.currentId = null
          this.editMode = false
          this.fetchBanks();
        }
      }
    },
    handleDeleteBank: async function(bankId) {
      this.errors = []
      this.loadingDeleteId = bankId;
      const response = await axios.delete(
        `${herokuUrl}/dashboard/delete-bank`,

        {
          data: {
            bankId
          },
          headers: {
            Authorization: getCookie("user"),
            "Content-Type": "Application/json"
          }
        },
        {
          bankId: bankId
        }
      );
      if (response.data.status) {
        this.loadingDeleteId = null
        // this.banks.splice(this.banks.findIndex(i => i.id === bankId), 1);
        this.bank = {
           name: "",
           name_en: "",
           number: ""
        }
        this.currentId = null
        this.editMode = false
        this.fetchBanks();
      } else {
        this.loadingDeleteId = null
        this.errors.push('error in deleting bank')
      }
    },
    switchAddMode: function() {
      this.editMode = false;
      this.currentId = null;
      this.bank.name_en = "";
      this.bank.name = "";
      this.bank.number = "";
    }
  ,
  fetchBanks:function(){
      this.loadingStart = true;
      axios
      .get(herokuUrl + "/dashboard/banks", {
        headers: {
          Authorization: getCookie("user")
        }
      })
      .then(response => {
        if (response.data.status) {
          this.loadingStart = false;
          this.banks = response.data.banks;
        } else {
          this.loadingStart = false;
          this.error = response.data.message;
        }
      })
      .catch(err => {
        this.loadingStart = false;
        this.error = err;
      });
  }
  },
  created() {
    this.fetchBanks();
  }
};
</script>

<style lang="scss" scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";

::-webkit-scrollbar {
  width: 0px;
  height: 5px;
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: darkgray;
}
.content-row {
  width: 100%;
  padding: 5px;
  // overflow-x: scroll;
  height: auto;
  display: flex;
  justify-content: space-around;
  border-radius: 5px;
  border-style: solid;
  border-color: transparent;
  background-color: #eeeeee;
  margin-bottom: 5px;
  cursor: pointer;
  &__measurement {
    cursor: default;
    padding-bottom: 10px !important;
  }
}
.content-heading {
  text-align: center;
  width: 14%;
  font-weight: bold;
  margin-bottom: 0;
}
.selectedRow {
  background-color: #ccc;
}
.content-col {
  text-align: center;

  width: 14%;
  overflow-x: scroll;
  margin-bottom: 0;
}
</style>
